import React from "react";

const CheckedIcon = () => (
  <svg
    className="checked-icon"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="20" height="20" rx="4" />
    <path d="M4 10L8 14L16 6" strokeWidth="2" />
  </svg>
);

export default CheckedIcon;
